import React from "react";
import cx from "classnames";

interface ISigninPageContentProps {
  children: React.ReactNode;
  className?: string;
}

export const SigninPageContent: React.FC<
  React.PropsWithChildren<ISigninPageContentProps>
> = ({ children, className }) => (
  <div
    className={cx(
      "relative mx-auto flex w-full max-w-[690px] flex-1 flex-col items-center gap-5 px-[15px] py-10 md:items-start",
      className
    )}
  >
    {children}
  </div>
);
